import * as React from 'react';
import styled from '@emotion/styled';
import { ExternalLinks, getGettingStartedLink } from '../../RoutesWidget';
import { TABLET_MEDIA } from '../../media';
import { CardWidget } from '../CardWidget';

const discordLogo = require('../../../media/discord-logo.png');

export const HomeActionCards: React.FC = () => (
  <S.Actions>
    <CardWidget
      featured
      href={getGettingStartedLink()}
      title="Start building."
      description="Turn your next idea into a working app. Create a project in OXIDE and make it yours."
      action="Create your first project"
    />
    <CardWidget
      href={ExternalLinks.DISCORD}
      title="Join the community."
      metadata={<S.DiscordLogo src={discordLogo} alt="Discord" />}
      description="Meet other developers and talk with the engineers building JourneyApps Platform."
      action="Join Discord"
    />
  </S.Actions>
);

namespace S {
  export const DiscordLogo = styled.img`
    display: block;
    width: 140px;
    max-width: 100%;
    height: auto;
  `;

  export const Actions = styled.div`
    display: grid;
    gap: 20px;
    ${TABLET_MEDIA} {
      grid-column: 1 / -1;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  `;
}
